import type { ReportHandler } from "web-vitals";
import { trackEventGTM } from "./gtm";

export const reportWebVitalsToGTM: ReportHandler = (metric) => {
  trackEventGTM("web_vitals", {
    metric_name: metric.name,
    metric_value: metric.value,
    metric_id: metric.id,
    metric_delta: metric.delta,
  });
};


